module.exports = __webpack_public_path__ + "static/img/jicheng.db3bb29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rocbox/jicheng.png
// module id = hJ56
// module chunks = 1